import { showroomGalleryImages } from "@/mocks/showroomData";

export default function ShowroomGallery() {
  return (
    <section className="w-full bg-[#111213] py-20 md:py-28 lg:py-32">
      <div className="w-full px-6 md:px-10 lg:px-16">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div>
            <p
              className="text-[11px] uppercase tracking-[0.28em] text-[#B8422E] mb-4"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              / Inside the Showroom
            </p>
            <h2
              className="text-3xl md:text-4xl lg:text-[52px] font-extrabold text-white leading-[1.06] tracking-[-0.02em]"
              style={{ fontFamily: "'Public Sans', sans-serif" }}
            >
              See It.
              <br />
              <span className="text-[#6C7278] font-light">Feel It. Own It.</span>
            </h2>
          </div>
          <a
            href="/catalog"
            className="inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.14em] text-[#6C7278] hover:text-white transition-colors whitespace-nowrap self-start md:self-auto"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Browse Full Collection
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        {/* Masonry-style grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/[0.04]">
          {/* Tall image — spans 2 rows on desktop */}
          <div className="row-span-2 overflow-hidden group cursor-pointer relative bg-[#111213]">
            <div className="w-full h-[420px] md:h-full min-h-[420px] overflow-hidden">
              <img
                src={showroomGalleryImages[0].image}
                alt={showroomGalleryImages[0].caption}
                className="w-full h-full object-cover object-center group-hover:scale-[1.03] transition-transform duration-700"
              />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-[#0d0d0d]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <p
                className="text-[11px] uppercase tracking-[0.16em] text-white/70"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {showroomGalleryImages[0].caption}
              </p>
            </div>
          </div>

          {/* Wide image */}
          <div className="lg:col-span-2 overflow-hidden group cursor-pointer relative bg-[#111213]">
            <div className="w-full h-[280px] md:h-[320px] overflow-hidden">
              <img
                src={showroomGalleryImages[1].image}
                alt={showroomGalleryImages[1].caption}
                className="w-full h-full object-cover object-center group-hover:scale-[1.03] transition-transform duration-700"
              />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-[#0d0d0d]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <p
                className="text-[11px] uppercase tracking-[0.16em] text-white/70"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {showroomGalleryImages[1].caption}
              </p>
            </div>
          </div>

          {/* Two normal images */}
          {showroomGalleryImages.slice(2, 4).map((img) => (
            <div key={img.id} className="overflow-hidden group cursor-pointer relative bg-[#111213]">
              <div className="w-full h-[260px] md:h-[300px] overflow-hidden">
                <img
                  src={img.image}
                  alt={img.caption}
                  className="w-full h-full object-cover object-center group-hover:scale-[1.03] transition-transform duration-700"
                />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-[#0d0d0d]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p
                  className="text-[11px] uppercase tracking-[0.16em] text-white/70"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  {img.caption}
                </p>
              </div>
            </div>
          ))}

          {/* Wide bottom image */}
          <div className="md:col-span-2 lg:col-span-3 overflow-hidden group cursor-pointer relative bg-[#111213]">
            <div className="w-full h-[280px] md:h-[340px] overflow-hidden">
              <img
                src={showroomGalleryImages[4].image}
                alt={showroomGalleryImages[4].caption}
                className="w-full h-full object-cover object-center group-hover:scale-[1.03] transition-transform duration-700"
              />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-[#0d0d0d]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <p
                className="text-[11px] uppercase tracking-[0.16em] text-white/70"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {showroomGalleryImages[4].caption}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
